/* eslint-disable */
// frontendGE/material-dashboard-react-main/src/components/common/AppNumberInput.js

import React from "react";
import PropTypes from "prop-types";
import TextField from "@mui/material/TextField";
import { NumericFormat } from "react-number-format";

const AppNumberInput = React.forwardRef(function AppNumberInput(
  {
    value,
    onValueChange,
    decimalScale = 0,
    fixedDecimalScale,
    allowNegative = false,
    allowLeadingZeros = false,
    min,
    max,
    isAllowed: externalIsAllowed,
    InputProps,
    inputProps,
    ...textFieldProps
  },
  ref
) {
  const defaultInputMode = decimalScale > 0 || fixedDecimalScale ? "decimal" : "numeric";

  const handleIsAllowed = (values) => {
    if (values.value === "") return true;

    if (
      min !== undefined &&
      values.floatValue !== undefined &&
      values.floatValue < min
    ) {
      return false;
    }

    if (
      max !== undefined &&
      values.floatValue !== undefined &&
      values.floatValue > max
    ) {
      return false;
    }

    return externalIsAllowed ? externalIsAllowed(values) : true;
  };

  return (
    <NumericFormat
      {...textFieldProps}
      value={value ?? ""}
      valueIsNumericString
      customInput={TextField}
      getInputRef={ref}
      type="text"
      thousandSeparator="."
      decimalSeparator=","
      decimalScale={decimalScale}
      fixedDecimalScale={fixedDecimalScale}
      allowNegative={allowNegative}
      allowLeadingZeros={allowLeadingZeros}
      isAllowed={handleIsAllowed}
      InputProps={InputProps}
      inputProps={{ inputMode: defaultInputMode, ...inputProps }}
      onValueChange={(values) => {
        onValueChange?.(values.value);
      }}
    />
  );
});

AppNumberInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onValueChange: PropTypes.func,
  decimalScale: PropTypes.number,
  fixedDecimalScale: PropTypes.bool,
  allowNegative: PropTypes.bool,
  allowLeadingZeros: PropTypes.bool,
  min: PropTypes.number,
  max: PropTypes.number,
  isAllowed: PropTypes.func,
  InputProps: PropTypes.object,
  inputProps: PropTypes.object,
};

export default AppNumberInput;
